import { Component } from '@angular/core';
import { RestApiService } from './services/rest-api.service';
import { RestApiEndpoints } from './enums/rest-api-endpoints';
import { CredentialsService } from './services/credentials.service';
import { FileService } from './services/file.service';
import { BroadcastService } from './services/broadcast.service';
import { BroadcastEvents } from './enums/broadcast-events';

declare function initFormsDropDown(): void;
declare function isValidStr(string: string): boolean;
declare function makeToast(message: string): void;
declare function closeModalWithID(modalID: string): void;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'BestatterPortal';

  salutation: string = '0';
  name: string = '';
  mail: string = '';
  phone: string = '';
  msg: string = '';
  isSafari: boolean = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  isRunningInElectron: boolean = this.credentialsService.isRunningInElectron

  constructor(
    private restApiService: RestApiService,
    private credentialsService: CredentialsService,
    private fileService: FileService,
    private broadcastService: BroadcastService) { }

  ngOnInit() {
    this.addDragAndDropHandler();
  }

  ngAfterViewInit() {
    initFormsDropDown();
  }

  private addDragAndDropHandler() {
    window.addEventListener("dragover", (event) => {
      event.preventDefault();
    });

    window.addEventListener("drop", (event) => {
      event.preventDefault();

      if (!this.credentialsService.checkAuthentication() || !event || !event.dataTransfer || !event.dataTransfer.files) { return; }

      let onlyPdfFiles = Array.from(event.dataTransfer.files).filter((file) => { return file.type == 'application/pdf'; });

      if (event.dataTransfer.files.length != onlyPdfFiles.length) {
        makeToast('Es werden nur die Dateien im PDF Format importiert');
      }

      this.fileService.importFiles(onlyPdfFiles, () => {
        this.broadcastService.dispatch(BroadcastEvents.reloadData);
      });
    });
  }

  sendMail() {
    if (!isValidStr(this.name) || !isValidStr(this.mail) || !isValidStr(this.msg)) {
      makeToast('Mindestens ein Pflichtfeld wurde nicht ausgefüllt.');
      return;
    }

    const payload = {
      salutation: this.salutation,
      name: this.name,
      email: this.mail,
      phone: this.phone,
      msg: this.msg
    };

    this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.contact, payload, (success, response) => {

      if (!success) {
        makeToast(response.data.message);
        return;
      }

      if (response.status != 'true') {
        makeToast('Fehler beim Senden.');
        return;
      }

      makeToast(response.message);

      setTimeout(() => closeModalWithID('contactModal'), 250);

    });

  }

}